  <!-- 客户档案>新增>基本信息 -->
<template>
  <div id="baseInfo">
    <div class="formbox">
      <el-form
        :model="baseInForm"
        :rules="rules"
        ref="baseInForm"
        label-width="110px"
        class="glo_formBox"
      >
        <div class="formBox_item">
          <el-form-item
            label="客户名称:"
            prop="customerName"
          >
            <el-input
              v-model="baseInForm.customerName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-form-item
            label="客户编号:"
            prop="customerNumber"
          >
            <el-input
              v-model="baseInForm.customerNumber"
              placeholder="不输入保存自动生成"
              clearable
            />
          </el-form-item>

          <el-form-item
            label="审核状态:"
            prop="approveStatus"
          >
            <el-select
              v-model="baseInForm.approveStatus"
              placeholder="请选择"
              disabled
            >
              <el-option
                label="待审核"
                value="shen_he_zhong:approve_status"
              />
              <el-option
                label="已审核"
                value="tong_guo:approve_status"
              />
              <el-option
                label="已审核"
                value="ju_jue:approve_status"
              />
            </el-select>
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item
            label="所属网点:"
            prop="deptId"
          >
            <el-select
              v-model="baseInForm.deptId"
              clearable
              remote
              filterable
              :remote-method="remoteDeptId"
              :loading="DeptPage.loading"
              v-loadmore:loadmore="'getDeptList'"
              @clear="remoteDeptId('')"
              placeholder="输入网点进行匹配"
            >
              <el-option
                v-for="(item, index) in departments"
                :key="index"
                :label="item.departmentName"
                :value="item.deptId"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            label="业务员:"
            prop="salesmanId"
          >
            <el-select
              v-model="baseInForm.salesmanId"
              clearable
              remote
              filterable
              :remote-method="
                (query) => {
                  remoteObject(query, 'employee1');
                }
              "
              :loading="SalesmanPage.loading"
              v-loadmore:loadmore="'getObjectUserDownList1'"
              @clear="remoteObject('', 'employee1')"
              placeholder="输入业务员进行匹配"
            >
              <el-option
                v-for="(item, index) in employeeArr"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            label="责任人:"
            prop="personInChargeId"
          >
            <el-select
              v-model="baseInForm.personInChargeId"
              clearable
              remote
              filterable
              :remote-method="
                (query) => {
                  remoteObject(query, 'employee2');
                }
              "
              :loading="directorPage.loading"
              v-loadmore:loadmore="'getObjectUserDownList2'"
              @clear="remoteObject('', 'employee2')"
              placeholder="输入责任人进行匹配"
            >
              <el-option
                v-for="(item, index) in directorArr"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              />
            </el-select>
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item
            label="联系电话:"
            prop="tel"
          >
            <el-input
              v-model="baseInForm.tel"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-form-item
            label="手机号码:"
            prop="phone"
          >
            <el-input
              v-model="baseInForm.phone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-form-item
            label="联系人:"
            prop="contactsName"
          >
            <el-input
              v-model="baseInForm.contactsName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </div>
        <el-form-item
          style="width: 100%; border: 0"
          label="联系地址:"
          prop="aaa"
        >
          <div class="disFlexs">
            <el-select
              class="selectAddress"
              v-model="baseInForm.provinceName"
              @change="changeProvince"
              placeholder="请选择省"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in provinceArr"
                :key="index"
                :label="item.districtName"
                :value="item.districtName"
              />
            </el-select>
            <el-select
              class="selectAddress"
              v-model="baseInForm.cityName"
              @change="changeCity"
              placeholder="请选择市"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in cityArr"
                :key="index"
                :label="item.districtName"
                :value="item.districtName"
              />
            </el-select>
            <el-select
              class="selectAddress"
              v-model="baseInForm.areaName"
              placeholder="请选择区"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in districtArr"
                :key="index"
                :label="item.districtName"
                :value="item.districtName"
              />
            </el-select>
            <el-input
              class="selectAddress addressDetails"
              v-model="baseInForm.address"
              placeholder="请输入详细地址"
              clearable
            />
          </div>
        </el-form-item>

        <!-- <div class="formBox_item">
          <el-form-item label="合同编号:" prop="contractNo">
            <el-input v-model="baseInForm.contractNo" placeholder="请输入" clearable />
          </el-form-item>

          <el-form-item label="合同开始时间:" label-width="120px" prop="contractStartTime">
            <el-date-picker v-model="baseInForm.contractStartTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
          </el-form-item>

          <el-form-item label="合同结束时间:" label-width="120px" prop="contractEndTime">
            <el-date-picker v-model="baseInForm.contractEndTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
          </el-form-item>
        </div>-->

        <div class="formBox_item">
          <el-form-item
            label="是否月结:"
            prop="isMonth"
          >
            <el-select
              v-model="baseInForm.isMonth"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="还款日:">
            <el-row>
              <el-col :span="12">
                <el-select
                  v-model="baseInForm.repaymentStartDate"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in dayNums"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select
                  v-model="baseInForm.repaymentEndDate"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in dayNums"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="账单日:">
            <el-row>
              <el-col :span="12">
                <el-select
                  v-model="baseInForm.billingStartDate"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in dayNums"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select
                  v-model="baseInForm.billingEndDate"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in dayNums"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item
            label="结算方式:"
            prop="settlementMethodConfDictId"
          >
            <el-select
              v-model="baseInForm.settlementMethodConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in CollectionArr"
                :key="index"
                :label="item.val"
                :value="item.confDictId"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            label="付款账期:"
            prop="paymentPeriod"
          >
            <el-input
              v-model="baseInForm.paymentPeriod"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="账期计算方式:"
            prop="periodSumMethod"
          >
            <el-select
              v-model="baseInForm.periodSumMethod"
              placeholder="请选择"
            >
              <el-option
                label="按日计算"
                value="day:period_sum_method"
              />
              <el-option
                label="按月计算"
                value="month:period_sum_method"
              />
            </el-select>
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item
            label="是否开票:"
            prop="isInvoicing"
          >
            <el-select
              v-model="baseInForm.isInvoicing"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="税点:"
            prop="taxPoint"
          >
            <div class="disFlex">
              <el-input
                v-model="baseInForm.taxPoint"
                placeholder="请输入"
                clearable
              />
              <div>(%)</div>
            </div>
          </el-form-item>

          <el-form-item
            label="票据类型:"
            prop="invoiceTypeConfDictId"
          >
            <el-select
              v-model="baseInForm.invoiceTypeConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in invoiceTypes"
                :key="index"
                :label="item.key"
                :value="item.confDictId"
              />
            </el-select>
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item
            label="信用额度:"
            prop="creditLine"
          >
            <el-input
              v-model="baseInForm.creditLine"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="登录账号:"
            prop="userId"
          >
            <div class="hasBtn">
              <!-- username -->
              <el-select
                v-model="baseInForm.userId"
                clearable
                remote
                filterable
                :remote-method="
                  (query) => {
                    getAccountList(query);
                  }
                "
                @clear="getAccountList()"
                @focus="getAccountList()"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in customerArr"
                  :key="index"
                  :label="item.username"
                  :value="item.userId"
                />
              </el-select>
              <!-- <el-button class="glo_bgcMainColor zd">自动生成</el-button> -->
            </div>
          </el-form-item>

          <el-form-item
            label="是否厂家运输:"
            prop="isFactoryTransport"
            label-width="120px"
          >
            <el-select
              v-model="baseInForm.isFactoryTransport"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="formBox_item">
          <el-form-item
            label="是否停用:"
            prop="isStop"
          >
            <el-select
              v-model="baseInForm.isStop"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否需要回单:"
            required
            label-width="120px"
          >
            <el-select
              v-model="baseInForm.isRnorder"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="回单要求:">
            <div
              class="glo_disFlex"
              style="padding-right: 3px"
            >
              <el-select
                style="display: flex;"
                v-model="baseInForm.rnRequireConfDictId"
                placeholder="请选择"
                filterable
                clearable
                @change="changernRequireName"
              >
                <el-option
                  v-for="item in rnrderRequireList"
                  :key="item.confDictId"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
              <el-input
                class="miniInput"
                v-model="baseInForm.rnRequireCount"
                placeholder="份数"
                type="number"
              ></el-input>份
            </div>
          </el-form-item>
        </div>
        <div class="formBox_item">
          <el-form-item
            label="是否投保:"
            prop="isInsure"
          >
            <el-select
              v-model="baseInForm.isInsure"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="保险费率(%):">
            <el-input
              v-model="baseInForm.insuranceRate"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="是否需要分拣:"
            prop="isSorting"
            label-width="120px"
          >
            <el-select
              v-model="baseInForm.isSorting"
              placeholder="请选择"
            >
              <el-option
                label="是"
                :value="1"
              />
              <el-option
                label="否"
                :value="0"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="formBox_item">
          <el-form-item
            label="体积系数:"
            prop="volumeFactor"
          >
            <el-input
              v-model="baseInForm.volumeFactor"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item label="发票抬头:">
            <el-input
              v-model="baseInForm.invoiceInfo.header"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="纳税人识别号:">
            <el-input
              v-model="baseInForm.invoiceInfo.identifyNumber"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="地址、电话:">
            <el-input
              v-model="baseInForm.invoiceInfo.addrPhone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </div>
        <div class="formBox_item">
          <el-form-item label="开户行及账号:">
            <el-input
              v-model="baseInForm.invoiceInfo.bank"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="货物信息:">
            <el-input
              v-model="baseInForm.invoiceInfo.goodsInfo"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </div>

        <div class="formBox_item">
          <el-form-item
            class="textArea"
            style="width: 99%"
            label="备注:"
            prop="remarks"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="baseInForm.remarks"
            />
          </el-form-item>
        </div>
        <!-- <div class="formBox_item">
          <el-form-item label="客户等级:" prop="customerLevelConfDictId" label-width="120px">
            <el-select v-model="baseInForm.customerLevelConfDictId" placeholder="请选择" clearable @change="changeLeve">
              <el-option v-for="items in CustomerLevelList" :key="items.key" :label="items.key" :value="items.confDictId" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item class="textArea" style="width: 99%" label="备注:" prop="remarks">
          <el-input type="textarea" rows="2" v-model="baseInForm.remarks" />
        </el-form-item>
        <div>
          <div>上传图片</div>
          <uploadimgs @input="changeFileList_3" :fileNameLists="fileNameLists_3" :limit="9" />
        </div>-->
      </el-form>
    </div>
    <div class="btmBtns">
      <el-button
        class="glo_bgcMainColor saveBtns"
        @click="submit"
      >保 存</el-button>
    </div>
  </div>
</template>
<script >
import uploadimgs from '@/components/upLoadImgs.vue'
export default {
  components: {
    uploadimgs,
  },
  props: {
    common: {
      type: Object,
    },
  },
  watch: {
    $route(to, from) {
      let id = this.$route.query.customerId || "";
      if (to.path == "/Customers/CustomMOD/Edit" && id) {
        this.customerId = id
        this.GetData();
      }
    },
    common(val){
      console.log(val)
    }
  },
  data() {
    return {
      rnrderRequireList: [], //回单类型
      fileNameLists_3: [],
      customerId: this.common.customerId,
      provinceArr: null,
      cityArr: null,
      districtArr: null,
      departments: [],
      invoiceTypes: [],
      CollectionArr: [],
      employeeArr: [],
      directorArr: [],
      customerArr: [],
      dayNums: [],
      day: 31,
      baseInForm: {
        isStop: 0,
        isRnorder: 1,
        isInsure: 0,
        isSorting: 0,
        isInvoicing: 1,
        isFactoryTransport: 0,
        approveStatus: 'shen_he_zhong:approve_status',
        periodSumMethod: 'month:period_sum_method',
        invoiceInfo: {
          addrPhone: '',
          bank: '',
          goodsInfo: '',
          header: '',
          identifyNumber: '',
        },
      },
      defualtBaseInForm: {
        approveStatus: null,
        creditLine: null,
        customerName: null,
        deptId: null,
        isFactoryTransport: null,
        isInvoicing: null,
        isMonth: null,
        isStop: null,
        personInChargeId: null,
        salesmanId: null,
        settlementMethodConfDictId: null,
        address: null,
        areaName: null,
        billingEndDate: null,
        billingStartDate: null,
        cityName: null,
        contactsName: null,
        contractEndTime: null,
        contractNo: null,
        contractStartTime: null,
        customerNumber: null,
        invoiceTypeConfDictId: null,
        paymentPeriod: null,
        phone: null,
        provinceName: null,
        remarks: null,
        repaymentEndDate: null,
        repaymentStartDate: null,
        taxPoint: null,
        tel: null,
        userId: null,
        customerLevel: null,
        // customerLevelConfDictId: null,
      },

      rules: {
        customerName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],

        // salesmanId: [{ required: true, message: '请选择', trigger: 'change' }],
        // personInChargeId: [
        //   { required: true, message: '请选择', trigger: 'change' },
        // ],
        periodSumMethod: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        deptId: [{ required: true, message: '请选择', trigger: 'change' }],
        isMonth: [{ required: true, message: '请选择', trigger: 'change' }],
        settlementMethodConfDictId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isInvoicing: [{ required: true, message: '请选择', trigger: 'change' }],
        // paymentPeriod: [
        //   { required: true, message: '请输入帐期', trigger: 'blur' },
        // ],
        // creditLine: [
        //   { required: true, message: '请输入信用额度', trigger: 'blur' },
        // ],
        isFactoryTransport: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isStop: [{ required: true, message: '请选择', trigger: 'change' }],
        // isInsure: [{ required: true, message: '请选择', trigger: 'change' }],
        // isSorting: [{ required: true, message: '请选择', trigger: 'change' }],
        // volumeFactor: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      DeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      SalesmanPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      directorPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      customerPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      CustomerLevelList: [],
    }
  },
  created() {
    for (let i = 1; i < 32; i++) {
      let num = i
      if (i < 10) {
        num = '0' + i
      }
      this.dayNums.push(String(num))
    }

    if (this.customerId) this.GetData()
    this.getDeptList()
    this.GetConfDictValDownList('invoice_type')
    this.GetConfDictValDownList('settlement_method')
    this.getObjectUserDownList('employee1')
    this.getObjectUserDownList('employee2')
    // this.getObjectUserDownList("employee");
    this.getcustomer_level()
    this.getConfDictValDownList('rn_order_require')
    this.getParentName('中华人民共和国') //默认查到各省
  },
  methods: {
    // 选择省(收货地址)
    changeProvince(e) {
      this.defualtBaseInForm.cityName = ''
      this.defualtBaseInForm.areaName = ''
      this.cityArr = []
      this.districtArr = []
      if (e) {
        this.getCityName(e)
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.defualtBaseInForm.areaName = ''
      this.districtArr = []
      if (e) {
        this.getAreaName(e)
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      }
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.provinceArr = res.data.result.data || []
      })
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityArr = res.data.result.data || []
        })
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.districtArr = res.data.result.data || []
        })
    },
    // 获取账号列表
    getAccountList(name) {
      let param = {
        // name: name || "",
        username: name || '',
        pageStart: 1,
        pageTotal: 100,
      }
      this.$API.wtl_getAccountList(param).then((res) => {
        let datas = res.data.result.data || []
        let list =
          datas.filter(
            (item) => item.userStatus == 'zheng_chang:user_status'
          ) || []
        this.customerArr = list
      })
    },
    // 选择回单要求
    changernRequireName(e) {
      this.baseInForm.rnRequireName = ''
      this.rnrderRequireList.forEach((item) => {
        if (e == item.confDictId) {
          this.baseInForm.rnRequireName = item.key
        }
      })
    },
    changeFileList_3(array) {
      this.fileNameLists_3 = array
    },
    //客户等级
    getcustomer_level() {
      this.$COMAPI.getConfDictValDownList('customer_level').then((res) => {
        this.CustomerLevelList = res || []
      })
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || []
          if (dictType == 'rn_order_require') {
            // 回单类型
            this.rnrderRequireList = arrs
          }
        })
    },
    changeLeve(e) {
      if (e) {
        console.log(e)
        this.CustomerLevelList.forEach((item) => {
          if (item.confDictId == e) {
            this.baseInForm.customerLevel = item.key
            console.log(
              'this.baseInForm.customerLevel',
              this.baseInForm.customerLevel
            )
          }
        })
      }
    },

    // 修改获取数据详情
    GetData() {
      this.$API
        .customergetCustomerDetail({ customerId: this.customerId })
        .then((res) => {
          if (res.data.status === 'success') {
            let datas = res.data.result
            if (!datas.collecatinAccountInfo) {
              datas.invoiceInfo = {
                // addrPhone: '',
                // bank: '',
                // goodsInfo: '',
                // header: '',
                // identifyNumber: '',
              }
            }
            this.baseInForm = datas
            this.baseInForm.billingStartDate =
              this.baseInForm.billingStartDate?.split(' ')[0].split('-')[2] ||
              ''
            this.baseInForm.billingEndDate =
              this.baseInForm.billingEndDate?.split(' ')[0].split('-')[2] || ''

            this.baseInForm.repaymentStartDate =
              this.baseInForm.repaymentStartDate?.split(' ')[0].split('-')[2] ||
              ''
            this.baseInForm.repaymentEndDate =
              this.baseInForm.repaymentEndDate?.split(' ')[0].split('-')[2] ||
              ''

            let fileIds = this.baseInForm.fileIds || []
            this.fileNameLists_3 = fileIds.map((item) => {
              let objs = {
                name: item.fileId,
                url: item.fileUrl,
              }
              return objs
            })
            if (datas.provinceName) {
              this.changeProvince(datas.provinceName)
            }
            if (datas.cityName) {
              this.changeCity(datas.cityName)
            }
          } else {
            this.$message.error(`${res.data.message}`)
          }
        })
    },
    // 滚动条加载更多
    loadmore(e) {
      let definePage =
        e === 'getObjectUserDownList1'
          ? 'SalesmanPage'
          : e === 'getObjectUserDownList2'
          ? 'directorPage'
          : e === 'getObjectUserDownList3'
          ? 'customerPage'
          : e === 'getDeptList'
          ? 'DeptPage'
          : ''
      let param =
        e === 'getObjectUserDownList1'
          ? 'employee1'
          : e === 'getObjectUserDownList2'
          ? 'employee2'
          : e === 'getObjectUserDownList3'
          ? 'employee'
          : ''
      let count = this[definePage].pageCount / this[definePage].pageTotal
      if (count > this[definePage].pageStart) {
        this[definePage].loading = true
        this[definePage].pageStart += 1
        this[e.replace(/[0-9]+/g, '')](param)
      } else {
        console.log('数据已全部加载')
      }
    },
    // 获取网点
    getDeptList(e, checkedData) {
      let query = {
        pageStart: this.DeptPage.pageStart,
        pageTotal: this.DeptPage.pageTotal,
        deptName: e,
        deptId: checkedData,
        isStorage: 1,
      }
      this.$API
        .wtl_getDeptList(query)
        .then((res) => {
          this.DeptPage.loading = false
          if (res.data.status === 'success') {
            let result = res.data.result?.data || []
            let arr = this.departments
            if (e) {
              this.departments = result
            } else {
              this.departments = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.deptId === item.deptId)
                ),
              ]
            }
            if (!e && !checkedData) {
              this.DeptPage.pageCount = res.data.result?.pageCount || 0
            }
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((catchres) => {
          this.DeptPage.loading = false
        })
    },
    // 所属网点远程搜索
    remoteDeptId(e) {
      this.DeptPage.pageStart = 1
      if (e !== '') {
        this.DeptPage.loading = true
        this.getDeptList(e)
      } else {
        this.getDeptList()
      }
    },

    // 获取字典数据--票据类型、支付方式
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === 'success') {
          if (param === 'invoice_type') {
            this.invoiceTypes = res.data.result
          }
          if (param === 'settlement_method') {
            this.CollectionArr = res.data.result
          }
        } else {
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    // 获取业务员、责任人下拉数据
    getObjectUserDownList(mark, e, checkedData) {
      let definePage =
        mark === 'employee1'
          ? 'SalesmanPage'
          : mark === 'employee'
          ? 'customerPage'
          : mark === 'employee2'
          ? 'directorPage'
          : ''
      let defineArr =
        mark === 'employee1'
          ? 'employeeArr'
          : mark === 'employee'
          ? 'customerArr'
          : mark === 'employee2'
          ? 'directorArr'
          : ''
      let query = {
        pageStart: this[definePage].pageStart,
        pageTotal: this[definePage].pageTotal,
        name: e,
        key: mark.replace(/[0-9]+/g, ''),
        number: checkedData,
      }
      this.$API
        .wtl_getObjectUserDownList(query)
        .then((res) => {
          this[definePage].loading = false
          if (res.data.status === 'success') {
            let result = res.data.result?.data || []
            let arr = this[defineArr]
            if (e) {
              this[defineArr] = result
            } else {
              this[defineArr] = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.number === item.number)
                ),
              ]
            }
            if (!e && !checkedData) {
              this[definePage].pageCount = res.data.result?.pageCount || 0
            }
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((catchres) => {
          this[definePage].loading = false
        })
    },
    // 业务员/责任人/登陆账号远程搜索
    remoteObject(e, param) {
      let definePage =
        param === 'employee1'
          ? 'SalesmanPage'
          : param === 'employee2'
          ? 'directorPage'
          : param === 'employee'
          ? 'customerPage'
          : ''
      this[definePage].pageStart = 1
      if (e !== '') {
        this[definePage].loading = true
        this.getObjectUserDownList(param, e)
      } else {
        this.getObjectUserDownList(param)
      }
    },

    // 提交
    submit() {
      // 正常提交
      let param = {
        ...this.baseInForm,
      }
      // for (let key in this.defualtBaseInForm) {
      //   if (this.baseInForm[key] || this.baseInForm[key] == 0) {
      //     eval("param." + key + "='" + this.baseInForm[key] + "'");
      //   } else {
      //     eval("param." + key + "=''");
      //   }
      // }
      // if (this.baseInForm.customerId)
      //   param.customerId = this.baseInForm.customerId;
      // // 取行政区值
      // let Arr = ["provinceName", "cityName"];
      // for (let i in Arr) {
      //   let p = Arr[i];
      //   param[p] = param[p]?.replace(/[0-9]+/g, "") || "";
      // }
      // 解构还款日、账单日的值
      param.billingStartDate = param.billingStartDate
        ? `2022-10-${param.billingStartDate} 00:00:00`
        : ''
      param.billingEndDate = param.billingEndDate
        ? `2022-10-${param.billingEndDate} 23:59:59`
        : ''
      param.repaymentStartDate = param.repaymentStartDate
        ? `2022-10-${param.repaymentStartDate} 00:00:00`
        : ''
      param.repaymentEndDate = param.repaymentEndDate
        ? `2022-10-${param.repaymentEndDate} 23:59:59`
        : ''

      // param.contractStartTime = param.contractStartTime
      //   ? `${param.contractStartTime} 23:59:59`
      //   : "";
      // param.contractEndTime = param.contractEndTime
      //   ? `${param.contractEndTime} 00:00:00`
      //   : "";

      let filds = this.fileNameLists_3.map((item) => {
        return item.name
      })
      param.fileIds = filds

      if (param.customerId) {
        // 修改接口
        this.$API.customerudpateCustomer(param).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message)
            this.RELOADPAGE()
          }
        })
      } else {
        // 新增接口
        this.$API.customeraddCustomer(param).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message)
            this.RELOADPAGE()
          }
        })
      }
    },
    RELOADPAGE() {
      this.$emit('RELOADPAGE')
    },
  },
}
</script>
<style scoped lang="less">
#baseInfo {
  margin: 60px 120px;
  // display: flex;
  // flex-wrap: wrap;
  .glo_formBox {
    display: block;
    .formBox_item {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .el-form-item {
        width: 32%;
        /deep/.el-range-separator {
          line-height: 24px;
        }
        .hasBtn {
          display: flex;
          .zd {
            height: 30px;
            line-height: 10px;
          }
        }
      }
    }
  }

  .disFlexs {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .selectAddress {
    border: 1px solid #ccc;
    margin-right: 10px;
    width: 180px !important;
  }
  .addressDetails {
    //   width: 380px !important;
    flex: 1;
  }
  .btmBtns {
    text-align: center;
    margin-top: 50px;
    .saveBtns {
      font-size: 16px;
    }
  }
}
.disFlex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
